'use client'

import React from 'react'
import SmallOptionCard from '@components/SmallOptionCard/SmallOptionCard'
import styles from './multiSelect.module.scss'

interface MultiSelectProps {
  data: any
  value?: string | boolean | null
  onChange?: (value: string | boolean | null) => void
}

const MultiSelect = ({ data, value, onChange }: MultiSelectProps) => {
  const { label, defaultSelected, optionCards, isRequired } = data
  const currentValue = value !== undefined ? value : defaultSelected

  const handleCardClick = (optionValue: string | boolean) => {
    if (!onChange) return

    const optionValueStr = String(optionValue)
    const currentValueStr = currentValue ? String(currentValue) : null

    // If clicking on already selected card
    if (currentValueStr === optionValueStr) {
      // If isRequired is true, don't allow deselection (must have at least one selected)
      if (isRequired) {
        return
      }
      // If isRequired is false, allow deselection
      onChange(null)
    } else {
      // Select the clicked option
      onChange(optionValue)
    }
  }

  return (
    <div className={styles.multiSelectContainer}>
      <p className={styles.label}>{label}</p>
      <div className={styles.optionsGrid}>
        {optionCards?.map((option: any, index: number) => {
          const optionValue = option?.value || option?.optionCardName
          const isSelected =
            currentValue === optionValue || currentValue === option?.optionCardName || currentValue === option?.value
          return (
            <SmallOptionCard
              key={option?.id || index}
              data={option}
              selected={isSelected}
              onClick={() => handleCardClick(optionValue)}
            />
          )
        })}
      </div>
    </div>
  )
}

export default MultiSelect
